import { render, staticRenderFns } from "./BigForm.vue?vue&type=template&id=6b167d40&scoped=true&"
import script from "./BigForm.vue?vue&type=script&lang=js&"
export * from "./BigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b167d40",
  null
  
)

export default component.exports